const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const Financial = 'Financial'
const Supervisor = 'Supervisor'
const Clerk = 'Clerk'
const Seller = 'Seller'
const YardOperator = 'YardOperator'
const Assistant = 'Assistant'
const SalesExecutive = 'SalesExecutive'
const CreditAnalyst = 'CreditAnalyst'
const Logistics = 'Logistics'

const clientRegisterRoutes = [
  {
    path: '/clients/create',
    name: 'CreateClient',
    meta: { 
      auth: true, 
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
    component: () => import('@/_backoffice/_registrations/components/client/register/CreateClient.vue'),
    children: [
      {
        path: 'exists/:id',
        name: 'ClientExist',
        component: () => import('@/_backoffice/_registrations/components/client/register/ClientExist.vue'),
      }
    ]
  },
  {
    path: '/clients',
    name: 'ClientList',
    meta: { 
      auth: true,
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
    component: () => import('@/_backoffice/_registrations/pages/Clients.vue'),
    children:[
      {
        path: ":id",
        name: "ShowClient",
        meta: { 
          auth: true,
          roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
        },
        component: () => import("@/_backoffice/_registrations/components/client/show/ShowClient.vue"),
        children: [
          {
            path: ":protested_transaction_id",
            name: "ProtestedTransaction",
            meta: { 
              auth: true,
              roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
            },
            component: () => import("@/_backoffice/_financial/components/order/ProtestVrtTransaction.vue"),
          }
        ]
      }
    ]
  },

]


export default clientRegisterRoutes
